module.exports = __webpack_public_path__ + "img/logo-powered-by.e6fca9d4.png";